import { Link } from "react-router-dom";
import { policies, groups, externalPages, indiaCompanies } from "../data/policies/index.js";

export default function Policies() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">Policies</div>
          <h1>Our policies and regulatory information.</h1>
          <p className="sub">
            Every published policy, with its version and status. UK borrower policies apply to
            Daksfirst Limited as lender. Group policies apply across every Daksfirst entity.
            Our India group companies publish their own policies on their own websites.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap">
          {groups.map((g) => (
            <div className="policy-group" key={g.key}>
              <div className="policy-group-head">
                <h2>{g.title}</h2>
                <p className="muted">{g.blurb}</p>
              </div>
              <ul className="policy-list">
                {policies.filter((p) => p.group === g.key).map((p) => (
                  <li key={p.slug}>
                    <Link to={"/" + p.slug}>
                      <span className="t">{p.title}</span>
                      <span className="s">v{p.version} &middot; {p.status}</span>
                    </Link>
                  </li>
                ))}
                {externalPages.filter((e) => e.group === g.key).map((e) => (
                  <li key={e.to}>
                    <Link to={e.to}>
                      <span className="t">{e.title}</span>
                      <span className="s">{e.status}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="policy-group">
            <div className="policy-group-head">
              <h2>India group companies</h2>
              <p className="muted">
                Regulated separately in India and required to publish their fair practices codes,
                grievance officers and ombudsman details on their own websites.
              </p>
            </div>
            <ul className="policy-list">
              {indiaCompanies.map((c) => (
                <li key={c.href}>
                  <a href={c.href} target="_blank" rel="noopener noreferrer">
                    <span className="t">{c.name} &#8599;</span>
                    <span className="s">{c.note}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
